import Sprite = Phaser.GameObjects.Sprite;
import {Basket} from "../model/basket";
import {KitchenAssetNames} from "./scene";
import {DataChange} from "@colyseus/schema";
import {IGameSprite} from "./game_sprite_base";

export class BasketSprite extends Sprite implements IGameSprite<Basket> {
    instance: Basket
    constructor(scene, instance:Basket) {
        super(scene, instance.x, instance.y, KitchenAssetNames.elements, 147);
        this.setScale(2)
        this.instance = instance
        // 44px touch target at scale 2 = 22px in local texture coords. Center on 16px sprite.
        const localHitSize = 22;
        const hitOffset = (16 - localHitSize) / 2;
        this.setInteractive(
            new Phaser.Geom.Rectangle(hitOffset, hitOffset, localHitSize, localHitSize),
            Phaser.Geom.Rectangle.Contains
        );
    }

    bindToInstance() {

    }

}
